exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-row-styles-link .linkCoachee {\n  cursor: pointer; }\n\n.table-row-styles-link .linkCoachee:hover {\n  color: #00838f !important;\n  font-weight: 700; }\n", ""]);

